import { Plugin } from "@ckeditor/ckeditor5-core";
import { ModelPosition as Position } from "@ckeditor/ckeditor5-engine";
import { ModelTreeWalker as TreeWalker } from "@ckeditor/ckeditor5-engine";

import ShowBlocksCommand from "./ShowBlocksCommand";

export default class ShowBlocksEditing extends Plugin {
  init() {
    const editor = this.editor;
    const model = editor.model;
    this._defineSchema();
    this._defineConverters();

    const command = new ShowBlocksCommand(editor, true);
    editor.commands.add("showBlocks", command);

    if (editor.plugins.has("TrackChangesEditing")) {
      const trackChangesEditing = editor.plugins.get("TrackChangesEditing");
      trackChangesEditing.enableCommand("showBlocks");
    }

    editor.on("cde:showBlocks", (_eventInfo, ...args) => {
      const value = !!args[0];
      editor.set("showBlocks", value);
      command.value = value;

      model.change((writer) => {
        const root = model.document.getRoot();
        const startPosition = new Position(root, [0]);
        const walker = new TreeWalker({ startPosition });
        for (const element of walker) {
          if (model.schema.isBlock(element.item)) {
            if (value) {
              writer.setAttribute("showBorder", true, element.item);
            } else {
              writer.removeAttribute("showBorder", element.item);
            }
          }
        }
      });
    });
  }

  _defineConverters() {
    const editor = this.editor;
    const conversion = editor.conversion;

    conversion.for("editingDowncast").attributeToAttribute({
      model: "showBorder",
      view: {
        key: "class",
        value: "showBorder",
      },
    });
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    schema.extend("$block", { allowAttributes: "showBorder" });

    schema.setAttributeProperties("showBorder", {
      copyOnEnter: true,
      isFormatting: false,
    });
  }
}
